import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Subject } from 'rxjs';
import { skip, switchMap } from 'rxjs/operators';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { LocationHttpService } from 'src/app/http/location-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-location-list',
    templateUrl: './location-list.component.html',
    styles: [],
})
export class LocationListComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private locationHttpService: LocationHttpService,
        private router: Router
    ) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.locationName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    confirmTogglePublish(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Publish' : 'Unpublish'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'publish' : 'unpublish'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.togglePublish(item, value);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.locationHttpService.deleteLocation(item.locationId).subscribe(() => {
            this.deleteItem(item.locationId);
            this.alert.addAlert({ type: 'success', message: 'Location Deleted successfully' });
        });
    }

    togglePublish(item: any, value: any) {
        this.locationHttpService.togglePublishLocation(item.locationId, value).subscribe(() => {
            this.togglePublishItem(item.locationId, value);
            this.alert.addAlert({ type: 'success', message: `Location ${value ? 'publish' : 'unPublish'} successfully` });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.locationId != itemId);
        this.items = this.tempItems;
    }

    togglePublishItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.locationId === itemId);
        item.isPublished = value;
        this.items = this.tempItems;
    }
}
